import { css } from 'styled-components/macro';
import { lowHeightScreens, smallScreens, mediumScreens } from './fontElements';

export const panelHeaderHeight = css`
  min-height: 44px;

  @media screen and (max-width: ${mediumScreens}) {
    min-height: 36px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    min-height: 32px;
  }
`;
